/**
 * Safely parse JSON from localStorage, returning null on failure.
 * Prevents app crashes from corrupted or tampered localStorage data.
 */
export const getStoredUser = () => {
    try {
        const stored = localStorage.getItem('userDetails');
        return stored ? JSON.parse(stored) : null;
    } catch (err) {
        console.error('Failed to parse stored user details:', err);
        localStorage.removeItem('userDetails');
        return null;
    }
};

const ALLOWED_USER_FIELDS = [
    '_id',
    'email',
    'firstName',
    'lastName',
    'role',
    'properties',
    'tenantId',
    'propertyScope',
    'capabilities',
    'needsPasswordChange',
];

export const sanitizeStoredUser = (user) => {
    if (!user || typeof user !== 'object') return null;

    const sanitized = {};
    for (const field of ALLOWED_USER_FIELDS) {
        if (Object.prototype.hasOwnProperty.call(user, field) && user[field] !== undefined) {
            sanitized[field] = user[field];
        }
    }

    return Object.keys(sanitized).length ? sanitized : null;
};

export const setStoredUser = (user) => {
    const sanitized = sanitizeStoredUser(user);
    if (!sanitized) {
        localStorage.removeItem('userDetails');
        return null;
    }

    localStorage.setItem('userDetails', JSON.stringify(sanitized));
    return sanitized;
};

export const clearStoredUser = () => {
    localStorage.removeItem('userDetails');
};
